import React, { useMemo } from "react";
import PageShell from "../components/layout/PageShell";

export default function Announcements() {

  const featuredAnnouncement = useMemo(
    () => ({
      id: 102,
      title: "Match des Élèves Magistrats en l'honneur des Grenadiers",
      summary: "Les élèves magistrats de l'EMA ont organisé un match de football en l'honneur des Grenadiers, l'équipe nationale haïtienne.",
      content: "Dans le cadre des activités de cohésion et de vie de l'École, les élèves magistrats ont disputé un match de football en l'honneur des Grenadiers d'Haïti. Cet événement sportif a permis de renforcer les liens entre les apprenants tout en célébrant l'esprit d'équipe et la fierté nationale.\n\nCe moment de convivialité illustre l'importance accordée par l'EMA à l'épanouissement personnel et collectif des futurs magistrats, au-delà de la formation académique.",
      type: "info",
      priority: "high",
      published_at: "2026-06-26",
      views_count: 20,
      gallery: [
        "/media/photos/match-ema.jpeg",
        "/media/photos/match-ema1.jpeg"
      ],
    }),
    []
  );

  const announcements = useMemo(
    () => [
      {
        id: 8,
        title: "Match des Élèves Magistrats en l'honneur des Grenadiers",
        summary: "Les élèves magistrats de l'EMA ont organisé un match de football en l'honneur des Grenadiers, l'équipe nationale haïtienne.",
        content: "Dans le cadre des activités de cohésion et de vie de l'École, les élèves magistrats ont disputé un match de football en l'honneur des Grenadiers d'Haïti.",
        type: "info",
        priority: "high",
        published_at: "2026-06-26",
        views_count: 100,
        category: "Vie de l'École",
        image: "/media/photos/match-ema.jpeg"
      },
      {
        id: 9,
        title: "",
        summary: "Communiqué officiel relatif au départ en stage des élèves magistrats de l'EMA.",
        content: "La Direction de l'École de la Magistrature informe les élèves magistrats des dispositions relatives à leur départ en stage.",
        type: "info",
        priority: "urgent",
        published_at: "2026-06-26",
        views_count: 90,
        category: "Communiqué",
        image: "/media/photos/",
        document: "/documents/info_ema.pdf"
      },
      {
        id: 7,
        title: "Reprise des cours – Second trimestre",
        summary: "La Direction des Études souhaite un bon retour aux élèves-magistrats et leur souhaite plein succès dans leurs activités de formation pour ce second trimestre.",
        content: "La Direction des Études souhaite un bon retour aux élèves-magistrats et leur souhaite plein succès dans leurs activités de formation pour ce second trimestre.",
        type: "info",
        priority: "urgent",
        published_at: "2026-04-13",
        views_count: 52,
        category: "Formation",
        image: "/media/photos/promotion8_1.jpg"
      },
      {
        id: 6,
        title: "Note d'information – Fin du premier trimestre et congés",
        summary: "La Direction des Études informe les formateurs que les élèves magistrats ont achevé leur premier trimestre.",
        content: "La Direction des Études informe les formateurs que les élèves magistrats ont achevé leur premier trimestre. Ils partiront en vacances à compter du 28 mars 2026 et reprendront les cours le lundi 13 avril 2026.\n\nLes formateurs programmés pour le second trimestre sont invités à prendre toutes les dispositions nécessaires en vue d'assurer la dispensation de leurs enseignements dans les conditions préalablement établies.\n\nLa Direction des Études compte sur la collaboration de chacun pour la bonne poursuite des activités académiques.",
        type: "info",
        priority: "high",
        published_at: "2026-03-27",
        views_count: 100,
        category: "Information",
        image: "/media/photos/proces1.jpeg"
      },
      {
        id: 5,
        title: "Formation probatoire des juges de paix : examens écrits",
        summary: "Les candidats concernés sont attendus le jeudi 19 mars 2026 pour passer les examens écrits dans les centres de Grand Sud et Grand Nord.",
        content: "Les candidats concernés sont attendus le jeudi 19 mars 2026 à compter de 8 heures AM pour passer les examens écrits. Les centres retenus sont les suivants : Grand Sud — Bergeaud, au local du Lycée Claudy Musseau ; Grand Nord — Auditorium du Bâtonnat du Cap-Haïtien, rue 22A. Matières annoncées : droit civil / procédure civile et droit pénal / procédure pénale.",
        type: "exam",
        priority: "urgent",
        published_at: "2026-03-12",
        views_count: 511,
        category: "Concours",
        image: "/media/photos/proces2.jpeg"
      },
      {
        id: 1,
        title: "Ouverture des activités de formation",
        summary: "L'École de la Magistrature informe le public et les candidats que les activités pédagogiques et institutionnelles se poursuivent.",
        content: "L'École de la Magistrature informe le public et les candidats que les activités pédagogiques et institutionnelles se poursuivent conformément au calendrier académique en vigueur.",
        type: "info",
        priority: "normal",
        published_at: "2026-03-01",
        views_count: 18,
        category: "Formation",
        image: "/media/photos/promotion8_2.jpg"
      },
      {
        id: 2,
        title: "Calendrier de la 8e promotion disponible",
        summary: "Le calendrier officiel de la 8e promotion (2025–2027) est disponible dans la section Formations.",
        content: "Le calendrier officiel de la 8e promotion (2025–2027) est disponible dans la section Formations. Les candidats et apprenants sont invités à le consulter régulièrement.",
        type: "exam",
        priority: "high",
        published_at: "2026-02-26",
        views_count: 32,
        category: "Promotion",
        image: "/media/photos/promotion8_3.jpg"
      },
      {
        id: 3,
        title: "Publication des avis officiels",
        summary: "Les communiqués relatifs aux concours, aux sessions de formation et aux informations administratives seront publiés progressivement.",
        content: "Les communiqués relatifs aux concours, aux sessions de formation et aux informations administratives seront publiés progressivement sur cette page officielle.",
        type: "result",
        priority: "normal",
        published_at: "2026-02-20",
        views_count: 21,
        category: "Information",
        image: "/media/photos/promotion8_4.jpg"
      },
      {
        id: 4,
        title: "Vérification régulière recommandée",
        summary: "Les usagers sont invités à consulter régulièrement cette rubrique afin de se tenir informés des annonces.",
        content: "Les usagers sont invités à consulter régulièrement cette rubrique afin de se tenir informés des annonces, convocations, résultats et autres communications officielles.",
        type: "urgent",
        priority: "urgent",
        published_at: "2026-02-15",
        views_count: 41,
        category: "Information",
        image: "/media/photos/promotion8_5.jpg"
      },
    ],
    []
  );

  const getTypeLabel = (type) => {
    switch (type) {
      case "exam":
        return "Examen";
      case "result":
        return "Résultat";
      case "urgent":
        return "Urgent";
      default:
        return "Information";
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case "exam":
        return "#0B2C5F";
      case "result":
        return "#059669";
      case "urgent":
        return "#DC2626";
      default:
        return "#3B82F6";
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "urgent":
        return "Urgent";
      case "high":
        return "Important";
      default:
        return null;
    }
  };

  const sortedAnnouncements = useMemo(() => {
    const priorityRank = (p) => (p === "urgent" ? 2 : p === "high" ? 1 : 0);
    return [...announcements].sort((a, b) => {
      const pr = priorityRank(b.priority) - priorityRank(a.priority);
      if (pr !== 0) return pr;
      const db = new Date(b.published_at || 0).getTime();
      const da = new Date(a.published_at || 0).getTime();
      return db - da;
    });
  }, [announcements]);

  const formatDateFR = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <PageShell
      title="Actualités"
      subtitle="Annonces et communiqués officiels de l'École de la Magistrature"
    >
      {/* Actualité principale */}
      <section className="ema-block">
        <div className="ema-card ema-card-hover" style={{
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: '20px',
          padding: 0,
          boxShadow: '0 4px 20px rgba(11,44,95,0.1)',
          overflow: 'hidden',
          transition: 'all 0.3s ease'
        }}>
          {/* Image de couverture */}
          <div style={{
            height: '340px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <img
              src={featuredAnnouncement.gallery?.[0] || "/media/photos/promotion8_4.jpg"}
              alt={featuredAnnouncement.title}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <div style={{
              position: 'absolute', inset: 0,
              background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.6) 100%)'
            }} />
          </div>

          <div style={{ padding: '32px' }}>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
              <span style={{ background: '#0B2C5F', color: '#fff', padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 600 }}>À la une</span>
              <span style={{ background: '#3B82F6', color: '#fff', padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 600 }}>Vie de l'École</span>
              <span style={{ background: '#F59E0B', color: '#fff', padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 600 }}>Important</span>
            </div>

            <h2 className="ema-h3" style={{ fontSize: '24px', fontWeight: 700, color: '#0B2C5F', marginBottom: '12px', lineHeight: 1.3 }}>
              {featuredAnnouncement.title}
            </h2>

            <p className="ema-lead" style={{ color: '#6B7280', marginBottom: '20px', lineHeight: 1.7 }}>
              {featuredAnnouncement.summary}
            </p>

            <p className="ema-paragraph" style={{ color: '#374151', marginBottom: '24px', lineHeight: 1.9, whiteSpace: 'pre-line' }}>
              {featuredAnnouncement.content}
            </p>

            {/* Galerie photos */}
            {featuredAnnouncement.gallery && featuredAnnouncement.gallery.length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#0B2C5F', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>Photos</h4>
                <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(featuredAnnouncement.gallery.length, 2)}, 1fr)`, gap: '12px' }}>
                  {featuredAnnouncement.gallery.map((src, idx) => (
                    <div key={idx} style={{ borderRadius: '12px', overflow: 'hidden', height: '220px' }}>
                      <img src={src} alt={`${featuredAnnouncement.title} - ${idx + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Document PDF */}
            {featuredAnnouncement.document && (
              <div style={{ marginBottom: '20px' }}>
                <a
                  href={featuredAnnouncement.document}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '10px',
                    padding: '14px 24px', background: 'rgba(11,44,95,0.05)',
                    border: '1px solid rgba(11,44,95,0.15)', borderRadius: '12px',
                    textDecoration: 'none', color: '#0B2C5F', fontWeight: 600, fontSize: '14px',
                    transition: 'all 0.2s'
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M12 18v-6"/><path d="M9 15l3 3 3-3"/>
                  </svg>
                  Télécharger le document (PDF)
                </a>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', padding: '16px 0', borderTop: '1px solid #e5e7eb' }}>
              <span className="ema-muted" style={{ fontSize: '14px', color: '#6B7280' }}>
                Publié le {formatDateFR(featuredAnnouncement.published_at)}
              </span>

              <span className="ema-muted" style={{ fontSize: '14px', color: '#6B7280' }}>
                {featuredAnnouncement.views_count} vue{featuredAnnouncement.views_count > 1 ? "s" : ""}
              </span>
            </div>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Autres annonces */}
      <section className="ema-block">
        <h2 className="ema-h3">Toutes les actualités</h2>
        <div style={{ marginTop: 24, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '24px' }}>
          {sortedAnnouncements.map((announcement) => (
            <div
              key={announcement.id}
              className="ema-card ema-card-hover"
              style={{
                background: '#fff',
                border: announcement.priority === "urgent" ? "2px solid #DC2626" : "1px solid #e5e7eb",
                borderRadius: '16px',
                padding: 0,
                boxShadow: '0 2px 12px rgba(11,44,95,0.08)',
                transition: 'all 0.3s ease',
                overflow: 'hidden',
                cursor: 'pointer'
              }}
            >
              {/* Image de couverture */}
              <div style={{
                height: '180px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <img
                  src={announcement.image || "/media/photos/promotion8_4.jpg"}
                  alt={announcement.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>

              <div style={{ padding: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
                  <span
                    style={{
                      background: getTypeColor(announcement.type),
                      color: '#fff',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '11px',
                      fontWeight: 600,
                      textTransform: 'capitalize'
                    }}
                  >
                    {getTypeLabel(announcement.type)}
                  </span>

                  <span
                    style={{
                      background: 'rgba(11,44,95,0.08)',
                      color: '#0B2C5F',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '11px',
                      fontWeight: 600
                    }}
                  >
                    {announcement.category}
                  </span>

                  {getPriorityLabel(announcement.priority) && (
                    <span
                      style={{
                        background: announcement.priority === "urgent" ? "#DC2626" : "#F59E0B",
                        color: '#fff',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '11px',
                        fontWeight: 600
                      }}
                    >
                      {getPriorityLabel(announcement.priority)}
                    </span>
                  )}
                </div>

                <h3 className="ema-h3" style={{ fontSize: '16px', fontWeight: 700, color: '#0B2C5F', marginBottom: '8px', lineHeight: 1.3 }}>
                  {announcement.title}
                </h3>

                <p className="ema-paragraph" style={{ color: '#6B7280', marginBottom: '16px', lineHeight: 1.6, fontSize: '14px' }}>
                  {announcement.summary}
                </p>

                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button
                    className="ema-btn ema-btn-ghost"
                    style={{
                      padding: '8px 16px',
                      fontSize: '13px',
                      fontWeight: 600,
                      color: '#0B2C5F',
                      background: 'transparent',
                      border: '1px solid #0B2C5F',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = '#0B2C5F';
                      e.currentTarget.style.color = '#fff';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#0B2C5F';
                    }}
                  >
                    Lire la suite →
                  </button>

                  {announcement.document && (
                    <a
                      href={announcement.document}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        padding: '8px 16px', fontSize: '13px', fontWeight: 600,
                        color: '#0B2C5F', background: 'rgba(11,44,95,0.05)',
                        border: '1px solid rgba(11,44,95,0.15)', borderRadius: '8px',
                        textDecoration: 'none', transition: 'all 0.2s'
                      }}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M12 18v-6"/><path d="M9 15l3 3 3-3"/>
                      </svg>
                      PDF
                    </a>
                  )}
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                  <span className="ema-muted" style={{ fontSize: '12px', color: '#6B7280' }}>
                    {formatDateFR(announcement.published_at)}
                  </span>

                  {Number(announcement.views_count) > 0 && (
                    <span className="ema-muted" style={{ fontSize: '12px', color: '#6B7280' }}>
                      {announcement.views_count} vue{announcement.views_count > 1 ? "s" : ""}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}